import React from 'react';

export const SelectIcon = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#5B2980"
        transform="rotate(-45 8.071 6.071)"
        d="M3.071 10.076v-8.01c0-.51.383-.93.883-.988l.117-.007c.552 0 1 .456 1 .995V9.07l7.005.001c.51 0 .93.383.988.883l.007.117c0 .552-.456 1-.995 1H4.07l-.09-.005-.03-.002c-.42-.048-.76-.356-.854-.762l-.02-.112c-.004-.038-.006-.076-.006-.114z"
      />
    </g>
  </svg>
);
